// extracted by mini-css-extract-plugin
export default {"carousel":"fF-z"};